export default "__VITE_ASSET__BHkwdALd__"